import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { ApiPartnerEnum } from '@claas-rdv/rdv-client';

export const resolveBackend: ResolveFn<string> = (route: ActivatedRouteSnapshot) => {
  switch (route.routeConfig?.path) {
    case 'security/auth0/login':
      return ApiPartnerEnum.CC3;
    case 'security/okta/login':
      return ApiPartnerEnum.SOFF;
    default:
      throw new Error('System not supported');
  }
};
